module.exports = __webpack_public_path__ + "static/media/logo_sm_on.ff6a54d5.png";